import { useReducer } from 'react';

/**
 * useState hook returns the current state and a function which you can use to set the new the state value. Unlike this.setState inside React components, state updates are not merged when you call the function returned by the hook.
 * https://twitter.com/kentcdodds/status/1064017933779664896?lang=en
 * @param initialState
 */
export const useSetState = <T extends {}>(initialState: T) =>
    useReducer((state, newState) => ({ ...state, ...newState }), initialState);
